import { FlowInputStep } from '../types/FlowInputStep';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export type GetFlowInputStepsParams = {
  readonly flowId: string;
};

export type GetFlowInputStepsResult = IResult & {
  readonly inputSteps: ReadonlyArray<FlowInputStep>;
  // flows?
  // connections?
};

export class GetFlowInputStepsRequest extends Request<GetFlowInputStepsParams, GetFlowInputStepsResult> {
  constructor(params: GetFlowInputStepsParams) {
    super('getFlowInputSteps', params);
  }
}
